// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aQDt","left":"styles_left__2KeA5"};